/**
 * Who the browser thinks it is signed in as.
 *
 * Authority: bead scope-njw; scope-caw.1 (staff, MSAL/Entra), scope-9xn
 * (customers, ACS email OTP).
 *
 * The shell does not authenticate anyone. It reads a `Viewer` out of context
 * and asks `resolveRoute` what to draw; the auth beads own the providers that
 * put a non-anonymous value there. The default is anonymous, so a provider that
 * is missing fails closed rather than rendering the staff tree to nobody in
 * particular.
 */
import { createContext, useContext } from 'react'

import { ANONYMOUS, type Viewer } from '../routes/_registry/access.ts'

export const ViewerContext = createContext<Viewer>(ANONYMOUS)

export function useViewer(): Viewer {
  return useContext(ViewerContext)
}
